import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import './Offcanvas.css';

function Offcanvas({ offcanvas, setOffcanvas }) {
    const handleClose = () => {
        setOffcanvas(false);
    };

    return (
        <div className={`offcanvas-outer ${offcanvas ? 'visible' : ''}`}>
            <div className="offcanvas-inner">
                <div className="offcanvas-header">
                    <h2 className='header-text'>Menu</h2>
                    <button className='close-button' onClick={handleClose}>
                        <i className='bx bx-x'></i>
                    </button>
                </div>
                <div className="offcanvas-content">
                    <div className='menu-list cta-text'>
                        <Link to='/' className='menu-item' onClick={{handleClose}}>Home</Link>
                        <Link to='/about' className='menu-item' onClick={{handleClose}}>About</Link>
                        <Link to='/courses' className='menu-item' onClick={{handleClose}}>Courses</Link>
                        <Link to='/placements' className='menu-item' onClick={{handleClose}}>Placements</Link>
                        <Link to='/blogs' className='menu-item' onClick={{handleClose}}>Blogs</Link>
                        <Link to='/contact' className='menu-item' onClick={{handleClose}}>Contact</Link>
                    </div>
                </div>
            </div>
        </div>
    );
}

Offcanvas.propTypes = {
    offcanvas: PropTypes.bool.isRequired,
    setOffcanvas: PropTypes.func.isRequired,
};

export default Offcanvas;
